exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-40f4e5fc] .description p{margin-bottom:0;font-size:var(--fontSize)}[data-v-40f4e5fc] .description h2{font-size:calc(var(--fontSize) + 1.5rem);font-size:calc(var(--fontSize) + 1rem)}[data-v-40f4e5fc] .description h3{font-size:calc(var(--fontSize) + .75rem)}[data-v-40f4e5fc] .description h4{font-size:calc(var(--fontSize) + .5rem)}[data-v-40f4e5fc] .description h5{font-size:calc(var(--fontSize) + .25rem)}[data-v-40f4e5fc] .description img{display:block;max-width:100%;margin-top:.25rem;margin-bottom:.25rem;height:auto}", ""]);

// exports
